import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ip, serviceurl } from '../constant/constant';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MapDataService {

  constructor(
    private http: HttpClient
  ) { }
  mapUrl:string = serviceurl + 'map';
  serviceurl: string = serviceurl;
    private  contentPrePatchSubject = new BehaviorSubject<any>('');
    contentRangesPatch$ = this.contentPrePatchSubject.asObservable();

  
  getMapData(mapcode:string,coords:{latitude:number,longitude:number}) {
    return this.http.post(this.mapUrl + '/get-map-data/'+mapcode +'/',coords)}

    setContentRangesData(data:any){
      this.contentPrePatchSubject.next(data);
    }

  getMapDetailsByMapId(map_id: string | number, user_id: number | string) {
    return this.http.post(this.serviceurl + 'api/map-detail/' + map_id +
      '/', { user_id });
  }

  updateMapThumbnail(map_id: string | number, payload: { user_id: number | string; thumbnail: string }) {
    return this.http.post(this.serviceurl + `api/map-thumbnail/${map_id}/`, payload);
  }
}
